var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.38 153.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n    .circle-check{\r\n      fill:none;\r\n      stroke:#8dc63f;\r\n      stroke-linecap:round;\r\n      stroke-linejoin:round;\r\n      stroke-width:12px;\r\n      stroke-dasharray: 1000;\r\n      stroke-dashoffset: 1000;\r\n      animation: dash 2s linear forwards;\r\n      }\r\n\r\n    @keyframes dash {\r\n    0% {\r\n      stroke-dashoffset: 1000;\r\n    }\r\n    25%{\r\n      stroke-dashoffset: 871;\r\n    }\r\n    75%, 100% {\r\n      stroke-dashoffset: 0;\r\n    }\r\n  "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle-check",
    d: "M68.31,101.48l28.45,24.77,58.85-69.89a70.64,70.64,0,1,1-12.36-12.28",
    transform: "translate(-23.31 -23.31)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.39944f37d4aeeaa234a49dfe3802dea4.svg";
export { ForwardRef as ReactComponent };